import React from 'react';
import s from './QuantityHandler.module.css';

type Props = {
	onChangeCallback: (
		id: string,
		action: '+' | '-' | 'manual',
		value?: number,
	) => void;
	count: number;
	productId: string;
    maxCount?: number;
    hidePlus?: boolean;
};

const QuantityHandler: React.FC<Props> = ({
	count,
	onChangeCallback,
	productId,
    maxCount,
    hidePlus,
}) => {
	const handleManualChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = Number(e.currentTarget.value);
		if (!Number.isNaN(value)) {
            const limited = typeof maxCount === 'number' ? Math.min(value, maxCount) : value;
            onChangeCallback(productId, 'manual', limited);
		}
	};

	return (
		<div className={s.container}>
            {!hidePlus && (
                <button
                    type="button"
                    className={`${s.button} ${s.plus}`}
                    onClick={() => {
                        if (typeof maxCount === 'number' && count >= maxCount) return;
                        onChangeCallback(productId, '+');
                    }}
                />
            )}
			<input value={count} onChange={handleManualChange} className={s.input} />
			<button
				type="button"
				className={`${s.button} ${s.minus}`}
				onClick={() => onChangeCallback(productId, '-')}
			/>
		</div>
	);
};

export default QuantityHandler;
